import React, { useState } from 'react';
import { motion } from 'framer-motion';
import EmigoInteractiveIcon from './EmigoInteractiveIcon';
import RibbonStreaks from './RibbonStreaks';
import FloatingBubbles from './FloatingBubbles';
const Hero = () => {
  const [hasBeenTapped, setHasBeenTapped] = useState(false);
  const [cutKey, setCutKey] = useState(0);
  return <section id="hero" className="relative overflow-hidden flex flex-col justify-center pt-6 pb-20 md:pt-10 md:pb-24" style={{
    backgroundColor: 'var(--cream)',
    minHeight: 'calc(100vh - 72px)'
  }} data-id="element-160">
      <RibbonStreaks cutKey={cutKey} data-id="element-161" />
      <FloatingBubbles data-id="element-162" />

      {/* Soft cream radial fade behind center content to calm the line artwork */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-[2]" style={{
      background: 'radial-gradient(ellipse 55% 50% at 50% 48%, rgba(251, 248, 244, 0.85) 0%, rgba(251, 248, 244, 0.55) 45%, rgba(251, 248, 244, 0) 75%)'
    }} data-id="element-163" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 sm:px-8 lg:px-10 text-center -translate-y-4 md:-translate-y-6" data-id="element-164">
        {/* Small pre-title */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-1.5" data-id="element-165">
          <span className="text-xs font-medium tracking-[0.2em] uppercase" style={{
          color: 'var(--coral)'
        }} data-id="element-166">
            Emotionally intelligent texting
          </span>
        </motion.div>

        {/* Main headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-[46px] sm:text-6xl md:text-7xl lg:text-[78px] font-normal leading-[0.92] tracking-tight mb-7 md:mb-8" style={{
        color: 'var(--navy)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-167">
          <span className="inline-flex items-center gap-2 md:gap-3 align-middle" data-id="element-168">
            <EmigoInteractiveIcon onTap={() => setHasBeenTapped(true)} onPop={() => setCutKey(k => k + 1)} data-id="element-169" />
            <span style={{
            color: 'var(--coral)'
          }} data-id="element-170">
              One Tap
            </span>
          </span>
          <br data-id="element-171" />
          <span className="text-[42px] sm:text-[56px] md:text-[64px] lg:text-[72px]" data-id="element-172">
            is all{' '}
            <em className="italic" style={{
            color: 'var(--navy-soft)'
          }} data-id="element-173">
              it takes
            </em>
          </span>
        </motion.h1>

        {/* Sub-headline — balanced two-line wrap */}
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className="mx-auto text-[18px] md:text-[20px] lg:text-[22px] leading-[1.4] mb-3.5" style={{
        color: 'var(--muted)',
        maxWidth: '800px'
      }} data-id="element-174">
          Reframe what you feel. Interpret what they mean.
          <br data-id="element-175" />
          Reply without the spiral.
        </motion.p>

        {/* CTA — stacked group */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center justify-center gap-2.5" data-id="element-176">
          <motion.a whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} href="https://apps.apple.com/us/app/emigo-better-texting/id6748092950" target="_blank" rel="noopener noreferrer" className="inline-block" data-id="element-177">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/55BSmF1FDX8kQyzwZAZdd8/download-on-the-app-store.svg" alt="Download on the App Store" className="h-[60px] md:h-16" data-id="element-178" />
          </motion.a>
          <p className="text-sm italic" style={{
          color: 'var(--muted-warm)'
        }} data-id="element-179">
            Free. No sign-up. No personal info.
          </p>
        </motion.div>
      </div>
    </section>;
};
export default Hero;